export const language: any = {
    LabelCarts: "购物车",
    Material: "材料",
    nodata: "购物车中没有数据"
  }
  

